import React from 'react';
import { useIntl } from 'react-intl';

import { Switch } from '@xsolla/ui-core';

import { SocialConnection } from '../../../api';
import { TextLeftBlock } from '../../../styled';

type Props = {
  socialSettings: SocialConnection;
  setSocialSettings: React.Dispatch<React.SetStateAction<SocialConnection>>;
};

enum SocialsWithExtraSettings {
  google = 'google'
  // facebook = 'facebook'
}

export const AdditionalSocialSettings = ({
  socialSettings,
  setSocialSettings
}: Props): JSX.Element | null => {
  const { provider, one_tap_login } = socialSettings;
  const intl = useIntl();

  if (Object.keys(SocialsWithExtraSettings).includes(provider)) {
    return (
      <TextLeftBlock>
        <Switch
          onChange={() =>
            setSocialSettings((prev) => ({
              ...prev,
              one_tap_login: {
                enabled: !prev.one_tap_login?.enabled
              }
            }))
          }
          checked={!!one_tap_login?.enabled}
          data-test-id={`${provider}_onetap`}
          caption={intl.formatMessage(
            { id: 'social-connection.settings.one-tap.subtitle' },
            {
              name: intl.formatMessage({
                id: `auth-methods.${provider}`
              })
            }
          )}>
          {intl.formatMessage(
            { id: 'social-connection.settings.one-tap.title' },
            {
              name: intl.formatMessage({
                id: `auth-methods.${provider}`
              })
            }
          )}
        </Switch>
      </TextLeftBlock>
    );
  }

  return <></>;
};
